import ApiGroupService from '@/services/api-group'
// import Vue from 'vue'

// initial state
const state = {
  data: [],
  totalData: 0,
  error: ''
}

const getters = {
  getData: state => state.data,
  getTotalData: state => state.totalData,
  getError: state => state.error
}

// mutations
const mutations = {
  setData(state, { data, total }) {
    state.data = data
    state.totalData = total
  },
  appendData(state, model) {
    state.data.push(model)
    state.totalData = state.totalData + 1
  },
  updateData(state, model) {
    const index = state.data.findIndex(m => m.id === model.id)
    state.data[index] = model
  },
  deleteData(state, id) {
    const index = state.data.findIndex(m => m.id === id)
    state.data.splice(index, 1)
  },
  setError(state, error) {
    state.error = error
  }
}

const actions = {
  listAll({ commit, state }, options) {
    return ApiGroupService.listAll(options).then((res) => {
      commit('setData', { data: res.result, total: res.paginate.total })
    })
  },
  findAll({ commit, state }, options) {
    return ApiGroupService.findAll(options).then((res) => {
      commit('setData', { data: res.result, total: res.paginate.total })
    })
  },
  save({ commit, state }, model) {
    commit('setError', '')
    if (!model.id) {
      return ApiGroupService.create(model).then((res) => {
        if (res.result) {
          commit('appendData', res.result)
        } else {
          commit('setError', (res.response && res.response.data) || res)
        }
        return res
      })
    } else {
      return ApiGroupService.update(model).then((res) => {
        commit('updateData', res.result)
        return res
      })
    }
  },
  delete({ commit, state }, id) {
    return ApiGroupService.delete(id).then((res) => {
      commit('deleteData', id)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
